// Sprint chatgpt-user-bubble (D-036 D3) — day + time stamp above every
// user message. "Hoy 17:50" / "Ayer 09:12" / "18 ago 17:50" /
// "18 ago 2025, 17:50" (year only when it differs from `now`'s).

import type { Locale } from '../i18n';

const LOCALE_TAG: Record<Locale, string> = { en: 'en-GB', es: 'es-ES' };

function sameDay(a: Date, b: Date): boolean {
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
}

export function formatMessageStamp(
  iso: string,
  locale: Locale,
  labels: { today: string; yesterday: string },
  now: Date = new Date(),
): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const tag = LOCALE_TAG[locale];
  const time = new Intl.DateTimeFormat(tag, { hour: '2-digit', minute: '2-digit' }).format(d);
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  if (sameDay(d, now)) return `${labels.today} ${time}`;
  if (sameDay(d, yesterday)) return `${labels.yesterday} ${time}`;
  const dayOpts: Intl.DateTimeFormatOptions =
    d.getFullYear() === now.getFullYear()
      ? { day: 'numeric', month: 'short' }
      : { day: 'numeric', month: 'short', year: 'numeric' };
  const day = new Intl.DateTimeFormat(tag, dayOpts).format(d).replace(/\.$/, '');
  return d.getFullYear() === now.getFullYear() ? `${day} ${time}` : `${day}, ${time}`;
}
